import { render } from "./PersonaFrameworkEditor.vue?vue&type=template&id=55e3f03a&scoped=true"
import script from "./PersonaFrameworkEditor.vue?vue&type=script&lang=js"
export * from "./PersonaFrameworkEditor.vue?vue&type=script&lang=js"

import "./PersonaFrameworkEditor.vue?vue&type=style&index=0&id=55e3f03a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e3f03a"]])

export default __exports__